import { DataProvider, Record } from 'react-admin'

const fakeSyncLogs: Record[] = []

const provider = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getList: (resource, params) =>
    Promise.resolve({
      data: fakeSyncLogs,
      total: fakeSyncLogs.length,
    }),
} as DataProvider

export default provider
